<template>
  <div>
    <div class="course-item-header">
      <div class="jinliyi" style="overflow: hidden">
        <img style="float: left" src="./images/fenlei.png" alt="" />
        <p class="cpjl" style="float: left">{{ cateId.name }}</p>
        <ul class="toubuwzyi" id="aaa">
          <li class="course-item-cate" @click="handleChangeAllCate(cateId.id)" :class="curIdx === cateId.id ? 'current' : ''">全部</li>
          <li class="course-item-cate" :class="curIdx === innerItem.cate_id_chain ? 'current' : ''" v-for="innerItem in cateId.child" :key="innerItem.id" :title="innerItem.name" @click="handleChangeCate(innerItem.cate_id_chain)">{{ innerItem.name }}</li>
        </ul>
      </div>
    </div>
    <div class="jinlier" style="overflow: hidden">
      <!-- <div class="zixue" style="overflow: hidden;">
        <p class="chanping">产品经理自学课</p>
        <div
          style="
                  width: 36px;
                  height: 5px;
                  opacity: 1;
                  background: #ffffff;
                  margin-top: 15px;
                  margin-left: 31px;
                "
        ></div>
        <p class="shihe">了解哪些值钱的产品岗位适合你</p>
      </div> -->
      <div v-for="item in courses" :key="item.id" class="course-item" @click="handleToCourseDetail(item, item.pakeage)">
        <div v-if="item.pakeage == 1" class="biaoshi_kcb">课程包</div>
        <div class="course-item-img" :style="{ backgroundImage: 'url(' + item.cover + ')' }"></div>
        <div>
          <p class="course-item-name">{{ item.name }}</p>
        </div>
        <div class="course-item-info">
          <p class="course-item-check">查看课表</p>
          <!-- <p class="course-item-check">立即查看</p> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  data() {
    return {
      courses: [],
      curIdx: '',
      cate_id_chain: this.cateId.cate_id_chain,
    }
  },
  props: ['cateId'],
  created() {
    this.listCourses()
    this.curIdx = this.cateId.id
  },
  computed: {
    ...mapState(['org_id']),
  },
  methods: {
    // 查询课程列表
    listCourses() {
      const data = {
        org_id: this.org_id,
        cate_id_chain: this.cate_id_chain,
      }
      this.$axios.post('/stu/course/listCourses', data).then((res) => {
        if (res.data.code === 200) {
          this.courses = res.data.data.list
        }
      })
    },
    // 切换课程分类
    handleChangeCate(idx) {
      this.curIdx = idx
      this.cate_id_chain = idx
      this.listCourses()
    },
    handleChangeAllCate(idx) {
      this.curIdx = idx
      this.cate_id_chain = idx
      this.listCourses()
    },
    // 跳转课程详情
    handleToCourseDetail(item, index) {
      if (index == 0) {
        this.$router.push({ path: `/yueke3/${item.id}` })
      } else {
        console.log('23111===', item)
        this.$emit('custom-event', item)
      }
    },
  },
}
</script>
<style scoped>
p {
  margin: 0;
  padding: 0;
}
.jinlier {
  width: 100%;
  margin-top: 30px;
}
.biaoshi_kcb {
  position: absolute;
  width: 60px;
  height: 28px;
  margin-top: 10px;
  margin-left: 10px;
  opacity: 0.7;
  background: #000000;
  border-radius: 4px;
  text-align: center;
  line-height: 28px;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: Regular;
  color: #ffffff;
  z-index: 100;
}
.zixue {
  width: 300px;
  height: 300px;
  background: url(./images/zixue.png);
  float: left;
  margin-right: 20px;
}

.chanping {
  opacity: 1;
  font-size: 24px;
  font-family: MicrosoftYaHei, MicrosoftYaHei-Bold;
  font-weight: 700;
  text-align: left;
  color: #ffffff;
  margin-top: 26px;
  margin-left: 30px;
}

.shihe {
  opacity: 1;
  font-size: 16px;
  font-family: MicrosoftYaHei;
  text-align: left;
  color: #ffffff;
  margin-top: 29px;
  margin-left: 30px;
}

.genduoaa {
  width: 120px;
  height: 36px;
  /* padding: 8px 25px; */
  opacity: 1;
  border: 1px solid #ffffff;
  border-radius: 19px;
  text-align: center;
  line-height: 36px;
  font-size: 14px;
  color: #ffffff;
  margin-left: 150px;
  margin-top: 106px;
}

.genduoaa a {
  color: #ffffff;
}

.genduoaa:hover a {
  color: #10a675;
}

.genduoaa:hover {
  background-color: #e8eaec;
}

.course-item {
  border-radius: 4px;
  width: 300px;
  height: 300px;
  float: left;
  opacity: 1;
  border-radius: 3px;
  background-color: #fff;
  box-shadow: 0px 5px 0px rgb(0 0 0 / 1%);
  margin: 0 10px 20px 10px;
  cursor: pointer;
}
.course-item-img {
  border-radius: 4px 4px 0px 0px;
  width: 300px;
  height: 200px;
  background-size: cover;
  background-position: center;
}

.course-item-name {
  font-size: 18px;
  font-family: MicrosoftYaHei;
  color: #20242f;
  padding-left: 20px;
  margin-top: 15px;
  white-space:nowrap;
  overflow: hidden;
  text-overflow:ellipsis;
}
.course-item-info {
  margin-top: 15px;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
}
.course-item-info a {
  text-decoration: none;
}

.course-item-num {
  font-size: 14px;
  color: #808695;
  float: left;
  align-self: center;
}

.course-item-check {
  width: 91px;
  height: 32px;
  border: 1px solid #1872ed;
  border-radius: 16px;
  text-align: center;
  line-height: 32px;
  color: #1872ed;
  font-size: 14px;
  margin-left: auto;
}

.ckkb a {
  color: #ffffff;
}

.ckkb:hover a {
  color: #10a675;
}

.ckkb:hover {
  background-color: #e8eaec;
}
/* 精品课程 */
.course-item-cate {
  cursor: pointer;
}

.jinliyi {
  width: 100%;
}

.cpjl {
  opacity: 1;
  font-size: 28px;
  font-family: MicrosoftYaHei, MicrosoftYaHei-Bold;
  font-weight: 700;
  text-align: left;
  color: #202020;
  margin-left: 20px;
  line-height: 36px;
}
.toubuwzyi li {
  transition: all 0.5s;
  border-radius: 5px;
}
.toubuwzyi li:hover {
  background: linear-gradient(135deg,#73aaff, #0053ff);
  color: #fff;
}

.toubuwzyi li {
  font-size: 16px;
  color: #202020;
}

#aaa {
  margin-top: 3px;
}

#aaa li {
  list-style-type: none;
  width: 108px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  float: left;
  margin-left: 5px;
}

#aaa li.current {
  background: linear-gradient(135deg,#73aaff, #0053ff);
  color: #fff;
}

#aaa li {
  text-decoration: none;
}

.ckgd {
  opacity: 1;
  font-size: 14px;
  font-family: MicrosoftYaHei;
  text-align: left;
  color: #10a675;
  line-height: 19px;
  float: left;
  line-height: 36px;
  margin-left: 440px;
}
</style>
